import { Card } from "@/components/ui/card";
import { useSiteInfo } from "@/SiteInfo/hooks/use-site-info";
import { useNavigate } from 'react-router-dom';
import { IconApple, IconGift, IconMapPin, IconPercentage, IconTag, IconToolsKitchen2, type TablerIcon } from '@tabler/icons-react';

const defaultHallmarks = [
  { title: "Weekly Ad", subtitle: "View this week's deals", linkto: "/ads" },
  { title: "Digital Coupons", subtitle: "Save offers", linkto: "/coupons" },
  { title: "Store Locator", subtitle: "Find stores near you", linkto: "/locations" },
  { title: "Fresh Produce", subtitle: "Farm to table", linkto: "/products/fresh-produce" },
  { title: "Rewards", subtitle: "Earn points", linkto: "/rewards" },
  { title: "Recipes", subtitle: "Meal ideas", linkto: "/recipes" },
];

const icons: TablerIcon[] = [IconTag, IconPercentage, IconMapPin, IconApple, IconGift, IconToolsKitchen2];
const colors = ["text-orange-500", "text-emerald-500", "text-brand-primary", "text-green-500", "text-orange-500", "text-brand-secondary"];

export const QuickAccess = () => {
  const { data: siteInfo } = useSiteInfo();
  const hallmarks = siteInfo?.SiteHallmark?.length ? siteInfo.SiteHallmark : defaultHallmarks;
  const navigate = useNavigate();
  
  const items = hallmarks.map((h: any, index) => {
    const icon = icons[index % icons.length];
    const defaultLink = defaultHallmarks[index]?.linkto;
    return {
      icon: icon as TablerIcon,
      title: h.SiteHallmarkTitle ?? h.title ?? "",
      description: h.SiteHallmarkSubtitle ?? h.subtitle ?? "",
      color: colors[index % colors.length],
      linkTo: h.linkto ?? defaultLink
    };
  });

  return (
    <section className="py-8 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {items.map((feature, index) => (
            <Card
              key={index}
              onClick={() => feature.linkTo && navigate(feature.linkTo)}
              className="p-4 text-center hover:shadow-lg transition-all cursor-pointer group bg-card border-border"
            >
              <div className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-neutral-100 group-hover:scale-110 transition-transform">
                  <feature.icon className={`h-6 w-6 ${feature.color}`} />
                </div>
                <h3 className="font-semibold text-sm text-foreground">{feature.title}</h3>
                <p className="text-xs text-muted-foreground">{feature.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
